<template>
  <div class="finishApply">
    <img src="../../assets/images/ic-xfcg.png" class="applysuc_img" />
    <p class="tips">入驻申请已提交<br/>审核结果将以短信发送<br/><span class="view_btn">请注意查收短信</span></p>
  </div>
</template>

<script>
export default {
  name: "finishApply",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped lang="stylus">
.finishApply {
    height:100vh;
    background-color: #fff;
    text-align: center;
    max-width:375PX;
    margin:0 auto;

    .applysuc_img {
        width: 120PX;
        height: 120PX;
        margin-top: 92PX;
    }

    .tips {
        font-size: 15PX;
        color: #333333;
        line-height: 22PX;
        margin-top: 16PX;
        margin-bottom: 28PX;
        // text-align:center;
    }

    .view_btn {
        color: #3760FF;
    }
}
</style>
